<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSharedUi } from '@/composables/useSharedUi'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import CustomButton from '@/components/customButton/CustomButton.vue'

const isActive = ref(false)
const router = useRouter()
const { t } = useI18n()
const { hideMessageMenu } = useSharedUi()
const { createUmsokn } = useUmsokn()

const props = defineProps<{
  setLoading?: (value: boolean) => void
}>()

// App ID for "Lán greiðslufrestur"
const APP_ID = 14

async function openApplication() {
  isActive.value = true
  try {
    props.setLoading?.(true)
    const newApp = await createUmsokn(APP_ID)
    if (newApp) {
      hideMessageMenu()
      const step =
        newApp.currentStep && newApp.currentStep > 0
          ? newApp.currentStep + 1
          : 1
      props.setLoading?.(false)
      router.push({ query: { step } })
    } else {
      console.error('Application was not created.')
      props.setLoading?.(false)
    }
  } catch (err) {
    console.error('Failed to create application:', err)
    props.setLoading?.(false)
  }
}
</script>

<template>
  <div>
    <v-container class="scrollview py-10">
      <v-row justify="center">
        <v-col>
          <h1 :class="[isActive ? 'active' : '', 'heading']">
            {{ t('lan_greidslufrest_umsokn_begin_header') }}
          </h1>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col md="6">
          <p class="bold">
            {{ t('lan_greidslufrest_umsokn_begin_text_bold') }}
          </p>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col md="7">
          <p class="forms__header">
            {{ t('lan_greidslufrest_umsokn_begin_disclaimer') }}
          </p>
          <p class="body">
            {{ t('lan_greidslufrest_umsokn_begin_disclaimer_text') }}
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-center">
          <CustomButton @click="openApplication">
            {{ t('lan_greidslufrest_umsokn_begin_button') }}
          </CustomButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
.heading {
  color: #194458;
  font-size: 55px;
  font-weight: 900;
  line-height: 75px;
  text-align: center;
  position: relative;
}
.bold {
  color: #194458;
  font-size: 21px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
  font-weight: bold;
}
.forms__header {
  color: #194458;
  font-size: 21px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 12px;
  font-weight: 600;
}
.body {
  color: #194458;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
}
.active {
  transition: all 0.8s linear;
  top: -900px;
  height: 20px;
  color: #194458;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
@media (max-width: 768px) {
  .scrollview { overflow-y: auto; padding-bottom: 91px; }
}
</style>
